import style from './style.module.css'

const Statistic = () => {
  return (
    <div className={style.statistic}>
      <div className={style.statistic_item}>
        <span className={style.statistic_number}>50</span>
        <span className={style.statistic_text}>interactions</span>
      </div>

      <div className={style.statistic_item}>
        <span className={style.statistic_number}>14</span>
        <span className={style.statistic_text}>relevant company</span>
      </div>

      <div className={style.statistic_item}>
        <span className={style.statistic_number}>50</span>
        <span className={style.statistic_text}>visited company</span>
      </div>

      <div className={style.statistic_item}>
        <span className={style.statistic_number}>50</span>
        <span className={style.statistic_text}>interactions</span>
      </div>

      <div className={style.statistic_item}>
        <span className={style.statistic_number}>14</span>
        <span className={style.statistic_text}>relevant company</span>
      </div>
    </div>
  )
}

export default Statistic
